export const initLoader = () => {
    const LOADER_ELEMENT = document.querySelector('#loader');
    if (LOADER_ELEMENT) return

    const cssLoader = document.createElement("link");
    cssLoader.rel = "stylesheet";
    cssLoader.href = "https://cdn069.b-cdn.net/assets/css/loader.css";
    document.head.appendChild(cssLoader);

    const loader = document.createElement('div');
    loader.id = 'loader';

    const loaderContent = document.createElement('div');
    loaderContent.classList.add('loader-content');

    const dualRing = document.createElement('div');
    dualRing.classList.add('lds-dual-ring');

    loaderContent.appendChild(dualRing);
    loader.appendChild(loaderContent);
    document.body.appendChild(loader);
}

export const showLoader = () => {
    const LOADER_ELEMENT = document.querySelector('#loader');
    if (LOADER_ELEMENT) {
        LOADER_ELEMENT.style.display = 'block';
    }
};

export const hideLoader = () => {
    const LOADER_ELEMENT = document.querySelector('#loader');
    if (LOADER_ELEMENT) {
        LOADER_ELEMENT.style.display = 'none';
    }
};